import React from 'react';
import {withFirestore} from 'react-firestore';
import SharePanel from '../components/SharePanel';
import LocationList from '../components/LocationList';
import TopHeaderMenu from '../components/TopHeaderMenu';
import MsgNetLoading from '../components/MsgNetLoading';

class LocationListScreen extends React.Component {
// ...
  constructor (props) {
    super(props)

    this.state = {
      locations: [],
      isLoading: true,
      evento: null,
      showSharePanel: false
    }
  }

  toogleSharePanel () {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }))
  }

  componentDidMount () {
    const {firestore} = this.props
    const eventoId = parseInt(this.props.match.params.eventoId, 10)

    firestore.doc('evento/' + eventoId).onSnapshot(snapshot => {
      let evento = snapshot ? snapshot.data() : null
      if (evento) {
        evento.id = snapshot.id
      }
      this.setState({evento})
    })

    firestore.collection('location/')
      .where('evento_id', '==', eventoId)
      .where('visible', '==', true)
      .onSnapshot((snapshot) => {
        let locations = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        this.setState({
          locations: locations.sort((a, b) => a.orden - b.orden),
          isLoading: false
        })
      })
  }

  render () {
    const {evento, locations, isLoading} = this.state

    return (
      <div>
        <TopHeaderMenu
          competicion={evento}
          evento={{nombre: 'Atletas por localización'}}
          onClickBack={null}
          onClickShare={this.toogleSharePanel.bind(this)}
        />
        {isLoading ? (
          <MsgNetLoading />
        ) : (
          <div>
            {this.state.showSharePanel && (
              <SharePanel
                close={this.toogleSharePanel.bind(this)}
                url={`/${evento.id}/locations/`}
                title={`Atletas por location en ${evento.nombre}`}
              />
            )}
            {(evento && evento.visible) ? (
              <div className={'container--padding'}>
                <LocationList locations={locations} evento={evento} />
              </div>
            ) : (
              <div>
                <br />
                <h2 className={'text-center'}>No se ha podido encontrar el evento especificado</h2>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

export default withFirestore(LocationListScreen)



// WEBPACK FOOTER //
// ./src/containers/LocationListScreen.js